import React from 'react';
import Hero from './components/mobile-app/Hero';
import Main from './components/mobile-app/Main';

const mobileApp = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default mobileApp;